import { colors } from "@theme/colors"

const VisaIcon = ({
  color = colors.backgroundSecondary,
  height = 64,
  width = 64,
}: {
  color?: string
  height?: number
  width?: number
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none">
      <path
        d="m23.26 11.495c-.515-.192-1.323-.401-2.323-.401-2.557 0-4.364 1.292-4.375 3.141-.021 1.359 1.281 2.125 2.265 2.583 1.011.469 1.349.761 1.344 1.177-.005.641-.808.927-1.547.927-1.027 0-1.584-.14-2.443-.5l-.319-.151-.364 2.136c.625.255 1.745.479 2.901.5 2.724 0 4.5-1.281 4.52-3.256.021-1.083-.676-1.905-2.161-2.583-.896-.437-1.457-.735-1.457-1.183 0-.396.479-.812 1.479-.812.859-.016 1.464.172 1.937.359l.245.109.359-2.057zm6.647-.224h-2c-.625 0-1.089.167-1.365.787l-3.844 8.713h2.719l.548-1.427 3.317.005c.083.333.317 1.421.317 1.421h2.401zm-17.027-.078h2.589l-1.62 9.504h-2.589l1.62-9.509zm-6.583 5.234.265 1.323 2.536-6.479h2.745l-4.084 9.484h-2.733l-2.24-8.031c-.047-.14-.104-.235-.245-.317-.755-.396-1.604-.719-2.541-.943l.031-.199h4.177c.563.021 1.021.199 1.177.803l.912 4.364zm20.406.974 1.037-2.661c-.016.025.213-.547.343-.907l.177.817.6 2.745h-2.157z"
        fill={color}
      />
    </svg>
  )
}

export default VisaIcon
